<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      @if(campana.nombre_campana){
      <div class="d-grid grid-prospect">
        <div>
          <div class="prospect-card">
            <div class="d-grid prospect-title">
              <div><h4 class="color-gray t-20">Campaña</h4></div>
              <div class="d-grid card-buttons-1 align-self-end">
                <button class="btn btn-primary">
                  Enviar correo
                </button>
                <div class="menu-container">
                  <div class="dropdown-container">
                    <button class="btn btn-round-outline">
                      <img src="assets/svg/tridots.svg" class="center-svg" />
                    </button>
                    <div class="dropdown-menu">
                      <button class="dropdown-item">
                        Modificar
                      </button>
                      <button class="dropdown-item">
                        Duplicar
                      </button>
                      <button class="dropdown-item">
                        Cancelar campaña
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="d-grid prospect-name">
                <div><img src="assets/svg/campaign-icon.svg" alt="" /></div>
                <div>
                  <h2 class="text-semibold">{{campana.nombre_campana}}</h2>
                </div>
              </div>
              <div class="d-flex flex-row gap-20 justify-center">
                <div class="text-tag color-org text-center">
                  <b>&Uacute;ltima actualizaci&oacute;n:</b> {{campana.updated_at | date:'dd/MM/yyyy'}}
                </div>
              </div>
              <div class="d-grid card-buttons-2">
                <div class="text-center event-item">
                  <button class="btn btn-round-outline" (click)="openNewCall()">
                    <img class="center-svg" src="assets/svg/call-icon.svg" />
                  </button>
                  <h5>Llamada</h5>
                </div>
                <div class="text-center event-item">
                  <button class="btn btn-round-outline" (click)="openNewTask()">
                    <img class="center-svg" src="assets/svg/task-icon.svg" />
                  </button>
                  <h5>Tarea</h5>
                </div>
                <div class="text-center event-item" (click)="openNewEvent()">
                  <button class="btn btn-round-outline">
                    <img class="center-svg" src="assets/svg/event-icon.svg" />
                  </button>
                  <h5>Evento</h5>
                </div>
                <div class="text-center event-item">
                  <button class="btn btn-round-outline" (click)="openSendMail()">
                    <img class="center-svg" src="assets/svg/mail-icon.svg" />
                  </button>
                  <h5>Correo</h5>
                </div>
              </div>

              <div class="info-card">
                <div class="d-grid info-card-title">
                  <h3>Informaci&oacute;n de la campaña</h3>
                  <div class="d-grid card-buttons-1">
                    <div>
                      <img src="assets/svg/edit.svg" alt="Editar" class="icon-clickable" />
                    </div>
                    <div class="d-grid">
                      <button class="btn btn-round-outline-mini">
                        <img class="center-svg arrow-toggle" src="assets/svg/arrow-up.svg" />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail">
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <td>Segmento de la campaña</td>
                        <td>{{campana.segmento.nombre_segmento}}</td>
                      </tr>
                      <tr>
                        <td>Tipo de envío</td>
                        <td>{{campana.tipo_envio === 'now' ? 'Inmediato' : 'Programado'}}</td>
                      </tr>
                      <tr>
                        <td>Fecha de inicio</td>
                        <td>{{campana.created_at | date:'dd/MM/yyyy'}}</td>
                      </tr>
                      <tr>
                        <td>Fecha de finalización</td>
                        <td>{{campana.created_at | date:'dd/MM/yyyy'}}</td>
                      </tr>
                      <tr>
                        <td>Cantidad de destinatarios</td>
                        <td>{{campana.segmento.entidades.length}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="info-card mt-4">
                <div class="d-grid info-card-title">
                  <h3>Historial registro</h3>
                  <div class="d-grid card-buttons-1">
                    <div class="d-grid">
                      <button class="btn btn-round-outline-mini">
                        <img class="center-svg arrow-toggle" src="assets/svg/arrow-up.svg" />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail">
                  <table class="info-table">
                    <tbody>
                      <tr>
                        <td>Creado por:</td>
                        <td>
                          <div class="d-flex flex-row align-items-center color-org">
                            <img src="assets/svg/avatar.svg" alt="" />
                            <u>Ana Rodríguez</u>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-row align-items-center">
                            01-11-2025 10:30
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Modificado por:</td>
                        <td>
                          <div class="d-flex flex-row align-items-center color-org">
                            <img src="assets/svg/avatar.svg" alt="" />
                            <u>Carlos Martínez</u>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-row align-items-center">
                            05-11-2025 14:15
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="prospect-info">
          <div class="main-open-tab">
            <div class="open-tab-title">
              <div class="d-grid tab-title-detail">
                <div><h3 class="text-semibold">Progreso</h3></div>
                <div class="justify-self-end">
                  <button class="btn btn-primary">
                    Marcar etapa como completada
                  </button>
                </div>
              </div>
              <div class="d-grid progress-status mt-3">
                <div class="status-number-one active">
                  <span class="status-text">Contacto inicial <br> <span class="status-date-1">15 Octubre 2025</span> </span>
                </div>
                <div class="status-number-two active">
                  <span class="status-text">Calificación <br> <span class="status-date-1">20 Octubre 2025</span> </span>
                </div>
                <div class="status-number-three inactive">
                  <span class="status-text">Propuesta <br> <span class="status-date-1">Pendiente</span> </span>
                </div>
              </div>
            </div>
            <div class="open-tab-title mt-4">
              <div class="tab-body">
                <app-nav-campaigns></app-nav-campaigns>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
